"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Grid = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const Dimensions_1 = require("../../utils/Dimensions");
const Grid_utils_1 = require("./Grid.utils");
const StyledGrid = styled_components_1.default.div `
    display: grid;
    grid-auto-flow: ${({ autoFlow }) => autoFlow};
    grid-auto-rows: ${({ autoRows }) => autoRows};
    grid-auto-columns: ${({ autoColumns }) => autoColumns};
    align-items: ${({ alignItems }) => alignItems};

    ${({ columns }) => (0, Grid_utils_1.generateGridColumnStyles)(columns)};
    ${({ gap, rowGap, columnGap }) => (0, Grid_utils_1.generateGridGapStyles)(gap, rowGap, columnGap)};
`;
const Grid = ({ columns = 1, gap = Dimensions_1.Dimensions.d16, rowGap = gap, columnGap = gap, autoFlow = "row", autoRows = "1fr", autoColumns = "auto", children, ...restProps }) => {
    return (react_1.default.createElement(StyledGrid, { columns: columns, gap: gap, rowGap: rowGap, columnGap: columnGap, autoFlow: autoFlow, autoRows: autoRows, autoColumns: autoColumns, ...restProps }, children));
};
exports.Grid = Grid;
//# sourceMappingURL=Grid.js.map